// InfoIcon.jsx
import React from 'react';

export default function InfoIcon({ className, onClick }) {
  return (
    <svg onClick={onClick} className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 1.875C5.51562 1.875 1.875 5.51562 1.875 10C1.875 14.4844 5.51562 18.125 10 18.125C14.4844 18.125 18.125 14.4844 18.125 10C18.125 5.51562 14.4844 1.875 10 1.875ZM10.8203 14.0625H9.17969V9.17969H10.8203V14.0625ZM10.8203 7.57812H9.17969V5.9375H10.8203V7.57812Z"
        fill="#00A3DA"
      />
    </svg>
  );
}
